import { createContext } from 'react';

const ActivatedTablesContext = createContext(null);

export default ActivatedTablesContext;
